var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3828 19.9242C12.4981 19.8765 12.6062 19.8063 12.7006 19.7136C12.703 19.7112 12.7055 19.7088 12.7079 19.7063L19.7071 12.7071C20.0976 12.3166 20.0976 11.6835 19.7071 11.2929C19.3166 10.9024 18.6834 10.9024 18.2929 11.2929L13 16.5858L13 5.00004C13 4.44776 12.5523 4.00004 12 4.00004C11.4477 4.00004 11 4.44776 11 5.00004L11 16.5858L5.70711 11.2929C5.31658 10.9024 4.68342 10.9024 4.29289 11.2929C3.90237 11.6835 3.90237 12.3166 4.29289 12.7071L11.2929 19.7071C11.4858 19.9001 11.7379 19.9977 11.9908 20M12.3828 19.9242C12.2676 19.9719 12.1415 19.9988 12.0092 20L12.3828 19.9242Z",
    fill: "white",
    fillOpacity: 0.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.097fc25a58c0e7318732e3774cf8fb63.svg";
export { ForwardRef as ReactComponent };